"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Diagnosis = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const toolbox_1 = require("@streem/toolbox");
const Diagnosis = ({ diagnoses, disposition, outOfScopeDiscussion, outOfScopeDiscussionReasons, refundRequest, refundReason, dataIdPrefix, singleColumn = false, diagnosisStyles, keyValueStyles, }) => {
    const theme = (0, ui_react_1.useTheme)();
    const showOutOfScopeDiscussionYn = typeof outOfScopeDiscussion === 'boolean';
    const showRefundRequestYn = typeof refundRequest === 'boolean';
    const effectiveTitleFontSize = ((diagnosisStyles === null || diagnosisStyles === void 0 ? void 0 : diagnosisStyles.titleFontSize) ||
        theme.text.size.mediumLarge);
    const effectiveItemFontSize = ((keyValueStyles === null || keyValueStyles === void 0 ? void 0 : keyValueStyles.fontSize) || theme.text.size.medium);
    const Tile = singleColumn ? DiagnosisColumnTile : DiagnosisRowTile;
    return ((0, jsx_runtime_1.jsxs)(DiagnosisWrapper, { children: [(0, jsx_runtime_1.jsx)(HeaderWrapper, Object.assign({ titleFontSize: effectiveTitleFontSize, "data-testid": `${dataIdPrefix}-diagnosis-header` }, { children: "Diagnosis" })), (0, jsx_runtime_1.jsxs)(Tile, { children: [(0, jsx_runtime_1.jsx)(TileSegmentForArray, { title: "Diagnosis", values: diagnoses, fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix }), (0, jsx_runtime_1.jsx)(TileSegmentForSingleValue, { title: "Disposition", value: disposition, fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix }), showOutOfScopeDiscussionYn && ((0, jsx_runtime_1.jsx)(TileSegmentForSingleValue, { title: "Out of Scope Discussion", value: outOfScopeDiscussion ? 'Yes' : 'No', fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })), Array.isArray(outOfScopeDiscussionReasons) && ((0, jsx_runtime_1.jsx)(TileSegmentForArray, { title: "Out of Scope Discussion Reason", values: outOfScopeDiscussionReasons, fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })), showRefundRequestYn && ((0, jsx_runtime_1.jsx)(TileSegmentForSingleValue, { title: "Refund Request", value: refundRequest ? 'Yes' : 'No', fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })), refundReason && ((0, jsx_runtime_1.jsx)(TileSegmentForSingleValue, { title: "Refund Reason", value: refundReason, fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix }))] })] }));
};
exports.Diagnosis = Diagnosis;
const TileSegmentForArray = ({ title, values, fontSize, dataIdPrefix, }) => {
    const listItems = values.map((v, idx) => {
        return ((0, jsx_runtime_1.jsx)("li", Object.assign({ "data-testid": (0, toolbox_1.scrubDataId)(`${dataIdPrefix}-${title}-item-${idx}`) }, { children: v }), v));
    });
    return ((0, jsx_runtime_1.jsx)(TileSegment, Object.assign({ title: title, fontSize: fontSize, dataIdPrefix: dataIdPrefix }, { children: (0, jsx_runtime_1.jsx)(TileSegmentOL, Object.assign({ fontSize: fontSize, "data-testid": (0, toolbox_1.scrubDataId)(`${dataIdPrefix}-items-${title}`) }, { children: listItems })) })));
};
const TileSegmentForSingleValue = ({ title, value, fontSize, dataIdPrefix, }) => {
    return ((0, jsx_runtime_1.jsx)(TileSegment, Object.assign({ title: title, fontSize: fontSize, dataIdPrefix: dataIdPrefix }, { children: (0, jsx_runtime_1.jsx)(TileSegmentValue, Object.assign({ fontSize: fontSize, "data-testid": (0, toolbox_1.scrubDataId)(`${dataIdPrefix}-value-${title}`) }, { children: value })) })));
};
const TileSegment = ({ children, title, fontSize, dataIdPrefix, }) => {
    return ((0, jsx_runtime_1.jsxs)(TileSegmentWrapper, { children: [(0, jsx_runtime_1.jsx)(TileSegmentTitle, Object.assign({ fontSize: fontSize, "data-testid": (0, toolbox_1.scrubDataId)(`${dataIdPrefix}-diagnosis-key-${title}`) }, { children: title })), children] }));
};
const TileSegmentTitle = ui_react_1.styled.div(props => ({
    marginBottom: '0.5rem',
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
}));
const TileSegmentWrapper = ui_react_1.styled.div({
    minWidth: '30%',
});
const DiagnosisWrapper = ui_react_1.styled.section({
    display: 'inline-block',
    padding: '.75rem 0 0.4rem 0',
    width: '100%',
});
const HeaderWrapper = ui_react_1.styled.div(props => ({
    marginBottom: '.75rem',
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
    lineHeight: props.theme.text.lineHeight.medium,
    fontSize: props.titleFontSize,
}));
const DiagnosisRowTile = (0, ui_react_1.styled)(ui_react_1.Grid)(({ theme }) => ({
    backgroundColor: theme.colors.grey01A50,
    gridTemplateColumns: 'repeat(3, 1fr)',
    padding: '0.5rem 1rem',
    gap: '1rem',
}));
const DiagnosisColumnTile = (0, ui_react_1.styled)(ui_react_1.Grid)(({ theme }) => ({
    backgroundColor: theme.colors.grey01A50,
    gridTemplateColumns: '1fr',
    padding: '0.5rem 1rem',
    gap: '1rem',
}));
const TileSegmentOL = ui_react_1.styled.ol(props => ({
    margin: 0,
    padding: '0 0 0 1rem',
    fontFamily: props.theme.text.bodyFontFamily,
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    listStyleType: 'decimal',
    fontWeight: 400,
}));
const TileSegmentValue = ui_react_1.styled.span(props => ({
    fontFamily: props.theme.text.bodyFontFamily,
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    fontWeight: 400,
}));
//# sourceMappingURL=diagnosis.js.map